import React from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import {
  required,
  validEmail,
  uniqueEmail,
  inputHasErr,
  composeValidators,
  EMAIL_ALREADY_EXISTS_ERROR_CODE,
} from 'utils/validations'
import SwitchTo from 'components/SwitchTo'
import registrationStyles from 'styles/registrationForm.module.scss'
import clsx from 'clsx'
import { trackLoginLinkClick } from 'tracking/form'

const ErrorMessage = ({ children }) => (
  <p data-testid="email_error" className={formStyles.error}>
    {children}
  </p>
)

const Email = () => {
  const hasError = meta => meta.touched && meta.error
  return (
    <Field
      name="email"
      validate={composeValidators(required('email'), validEmail, uniqueEmail)}
    >
      {({ input, meta }) => (
        <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
          <label
            className={clsx(
              formStyles.layerLable,
              hasError(meta) && formStyles.error
            )}
          >
            Enter your Email ID
          </label>
          <input
            data-testid="email"
            className={`${inputHasErr(meta) &&
              formStyles.inputError} form-control ${
              formStyles.formTextFreeField
            }`}
            type="email"
            {...input}
          />
          {hasError(meta) && meta.error === EMAIL_ALREADY_EXISTS_ERROR_CODE && (
            <>
              <ErrorMessage>
                {/** TODO: Remove this to use meta.error when api is refactored to send same message */}
                This Email ID is already registered with us.
              </ErrorMessage>
              <SwitchTo
                styles={registrationStyles.loginLink}
                trackLoginClickFn={trackLoginLinkClick}
              />
            </>
          )}
          {hasError(meta) && meta.error !== EMAIL_ALREADY_EXISTS_ERROR_CODE && (
            <ErrorMessage>{meta.error}</ErrorMessage>
          )}
          {meta.touched.error}
        </div>
      )}
    </Field>
  )
}

export default Email
